import styled from 'styled-components'

export const ExistingCardWrapper = styled.div`
  height: 80vh;
  margin-top: 10px;

  .manage_text {
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x5};
    line-height: 140%;
  }

  .title_text {
    font-size: ${({ theme }) => theme.fontSize.xl};
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    margin: 0;
    color: ${({ theme }) => theme.colors.navyBlue};
  }
`

export const PaymentCard = styled.div``

export const AddNewCardContainer = styled.div``

export const CardContainer = styled.div`
  width: 95%;
  margin: 30px 0;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  height: 60px;
  padding: 10px;
  position: relative;
  &.active {
    background: rgba(87, 102, 255, 0.1);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 95%;
  }

  .svg_wrapper {
    width: 48px;
    height: 40px;
    background: #cdd2fd;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .user_card {
    display: flex;
    align-items: center;
    width: 100%;

    /* justify-content: space-between; */
  }

  .card_img {
    border-radius: 0;
    width: 48px;
    height: 40px;
  }

  .user_card {
    cursor: pointer;
  }

  .card_detail {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    cursor: pointer;
    &.active {
      background-color: red;
    }

    .card_detail_img {
      width: 48px;
      height: 40px;
    }
  }

  .card_arrow {
    position: absolute;
    top: 25px;
    right: 20px;
  }

  .suffix_expiry_wrapper {
    margin-left: 40px;
    margin-top: 10px;
  }

  .expiry_text {
    margin: 0;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.navyBlue};
    font-size: ${({ theme }) => theme.fontSize.x5};
  }

  .suffix_text {
    margin: 0;
    padding-bottom: 5px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.navyBlue};
    font-size: ${({ theme }) => theme.fontSize.x5};
  }

  .card_detail_text {
    /* display: flex; */
    margin-left: 40px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.navyBlue};
    font-size: ${({ theme }) => theme.fontSize.x5};
  }
`
